<template>
  <v-chip
    v-if="showSubmitted"
    :text="$bct('Application already submitted')"
    class="mr-2"
    color="success"
    data-testid="submitted-chip"
    rounded="sm"
    variant="tonal"
  />
  <v-chip
    v-if="showInProgress"
    :text="$bct('Application in progress')"
    class="mr-2"
    color="info"
    data-testid="in-progress-chip"
    rounded="sm"
    variant="tonal"
  />
  <v-chip
    v-if="showIneligible"
    :text="$bct('Child not eligible based on date of birth')"
    color="error"
    data-testid="ineligible-chip"
    rounded="sm"
    variant="tonal"
  />
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  showInProgress: {
    type: Boolean,
    default: false,
  },
  showIneligible: {
    type: Boolean,
    default: false,
  },
  showSubmitted: {
    type: Boolean,
    default: false,
  },
});
</script>
